module.exports = __webpack_public_path__ + "img/GibosaCrescente.185100cc.svg";